export default __webpack_public_path__ + "static/media/takuapaLogo.eff5e3d7.png";